module.exports = __webpack_public_path__ + "img/template-04.1196bcd8.svg";